'use client'

/* eslint-disable no-console */
/* eslint-disable react/no-danger */
/* eslint-disable arrow-body-style */
/* eslint-disable @typescript-eslint/quotes */
/* eslint-disable @typescript-eslint/no-floating-promises */
import Image from 'next/image'
import WidgetModal from '@components/WidgetModal/WidgetModal'
import {
  getAutoWidgetLayout,
  getHealthWidgetLayout,
  getCtaWidgetPurpleLayout,
  ContainerVisibility,
  shouldDisplayWidget,
  shouldHideHeader,
} from '@configs/productWidget.config'
import {
  getClassNames,
  getWidgetLayoutConfig,
  getHeroImageSize,
  getHideSectionState,
} from '@helpers/productWidgetHelper'
import { isVasWidget } from '@helpers/vasLandingPageHelper'
import { Colors } from '@enums/Colors'
import RatingStars from '@components/CustomerStory/RatingStars/RatingStars'
import Link from 'next/link'
import { BASE_URL } from '@components/MainWidget/common/commonConstants'
import { ACKO_LOGO_HORIZONTAL_GRADIENT_DARK } from '@components/utils/ackoLogoUrls'
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { NEWCAR_SEM_PAGE } from '@configs/components.config'
import { getUrlWithQueryParams } from '@utils/queryParamUtils'
import ProductWidgetNewLayout from './productWidgetNewLayout'
import ProductWidgetHeader from './subComponents/productWidgetHeader'
import ProductLobWidget from './subComponents/productLobWidget'
import ProductKeyFeaturesAndCta from './subComponents/productKeyFeaturesAndCta'
import styles from './productWidget.module.scss'

const ProductWidget = ({
  isMobileDevice,
  data,
  segmentEventCommonProperties,
  reqCookie,
  isSemPage,
  productWidgetData,
  lob,
  regexPatternsData,
}) => {
  const content = data?.data?.attributes
  const isVasLandingWidget = isVasWidget(content?.widget)
  if (content?.widget === NEWCAR_SEM_PAGE && productWidgetData) {
    const handleCtaClick = () => {
      void (async () => {
        await trackEvent('tap_btn_CTA_widget', {
          page_type: 'new_car_comparison',
          product: 'new_car_comparison',
          funnel: 'entry',
          cta_text: 'Check Savings-hero_cta',
          redirection_url: content?.cta?.link,
        })
        window.location.href = getUrlWithQueryParams(content?.cta?.link)
      })()
    }

    return (
      <div id="productWidget" className={styles.newCarSemContainer}>
        <div className={styles.semNavbar}>
          <Link href={BASE_URL}>
            <Image width={100} height={24} src={ACKO_LOGO_HORIZONTAL_GRADIENT_DARK} alt="Acko Company Logo" priority />
          </Link>
        </div>
        <div className={styles.hero}>
          <div className={styles.left}>
            <div className={styles.titleAndCta}>
              <div className={styles.content}>
                <p className={styles.heading}>{content.productWidgetMainHeading}</p>
                <p className={styles.subHeading}>{content.ProductWidgetSubHeading}</p>
                <p className={styles.disclaimer}>{content.disclaimer}</p>
              </div>
              <button type="button" onClick={handleCtaClick} className={styles.cta}>
                <div className={styles.ctaContent}>
                  <p className={styles.ctaHeading}>{content.widgetHeading}</p>
                  <p className={styles.ctaText}>{content.widgetCtaText}</p>
                </div>
                <Image
                  src="https://acko-cms.ackoassets.com/brand_hub_arrow_eb7bee7e37.svg"
                  alt="arrow"
                  height={32}
                  width={32}
                />
              </button>
              <button type="button" onClick={handleCtaClick} className={styles.mobileCtaContent}>
                <p>{content?.cta?.name}</p>
              </button>
            </div>
            <div className={styles.rating}>
              <RatingStars rating={4.6} total={5} starColor={Colors.StarColor} starBackgroundColor={Colors.GreyD} />
              <p>
                <span>4.6</span> stars with <span>3 lakh+</span> reviews on Google Play Store
              </p>
            </div>
          </div>
          <div className={styles.right}>
            <Image
              src={content?.productWidgetHeroImageDesktop?.data?.attributes?.url}
              className={styles.hideOnMobile}
              alt="Hero image desktop"
              width={605}
              height={403}
            />
            <Image
              src={content?.productWidgetHeroImageMobile?.data?.attributes?.url}
              className={styles.hideOnDesktop}
              alt="Hero image desktop"
              width={605}
              height={403}
            />
          </div>
        </div>
      </div>
    )
  }
  const { isAutoWidgetLayout, isSeoCarWidget, isOldLayout, isHealthWidgetPurpleLayout, isCtaPurpleLayout } =
    getWidgetLayoutConfig(content, lob, isSemPage, getAutoWidgetLayout, getHealthWidgetLayout, getCtaWidgetPurpleLayout)

  const THEME_CONFIG = {
    light: styles.lightTheme,
    dark: '',
  }

  if (!isOldLayout) {
    return (
      <ProductWidgetNewLayout
        isMobileDevice={isMobileDevice}
        data={data}
        segmentEventCommonProperties={segmentEventCommonProperties}
        reqCookie={reqCookie}
        isSemPage={isSemPage}
        productWidgetData={productWidgetData}
        regexPatternsData={regexPatternsData}
      />
    )
  }

  // Combining base and conditional classes
  const containerClassNames = getClassNames([styles.productWidgetMainContainer, styles.mainContainerSemLayout], {
    [styles.semPageHeader]: isSemPage && !isAutoWidgetLayout && !isHealthWidgetPurpleLayout && !isVasLandingWidget,
    [styles.seoPurpleVariant]: isSeoCarWidget,
    [styles.AbhalayoutWidthChange]: isHealthWidgetPurpleLayout,
    [styles.ctaPurpleLayoutStyles]: isCtaPurpleLayout,
    [styles.newVasLandingPageContainer]: isVasLandingWidget,
    [styles.extraTopMargin]: shouldHideHeader[content?.widget],
    [styles.hideWidget]: !productWidgetData,
  })

  const heroImageContainerClassNames = getClassNames([styles.semHeroImageWeb], {
    [styles.seoDontRenderContent]: isHealthWidgetPurpleLayout,
  })

  const titleAndFeaturesContainerClassNames = getClassNames([styles.titleAndKeyFeatures], {
    [styles.ctaPurpleSectionMargin]: isCtaPurpleLayout,
    [styles.changeLayoutWidth]: isVasLandingWidget,
  })

  return (
    <div id="productWidget" className={containerClassNames}>
      <div className={titleAndFeaturesContainerClassNames}>
        <ProductWidgetHeader
          content={content}
          isSeoCarWidget={isSeoCarWidget}
          reqCookie={reqCookie}
          THEME_CONFIG={THEME_CONFIG}
          isHealthWidgetPurpleLayout={isHealthWidgetPurpleLayout}
          isMobileDevice={isMobileDevice}
        />
        {shouldDisplayWidget(content?.widget, ContainerVisibility.HIDE) && (
          <ProductLobWidget
            content={content}
            isMobileDevice={isMobileDevice}
            segmentEventCommonProperties={segmentEventCommonProperties}
            reqCookie={reqCookie}
            isSemPage={isSemPage}
            isOldLayout={isOldLayout}
            regexPatternsData={regexPatternsData}
            isHealthWidgetPurpleLayout={isHealthWidgetPurpleLayout}
            widgetOptions={content?.widgetOptions}
          />
        )}
        <ProductKeyFeaturesAndCta
          content={content}
          isMobileView={false}
          isAutoWidgetLayout={isAutoWidgetLayout}
          isSeoCarWidget={isSeoCarWidget}
          THEME_CONFIG={THEME_CONFIG}
          segmentEventCommonProperties={segmentEventCommonProperties}
          renderCtaButton
          isHealthWidgetPurpleLayout={isHealthWidgetPurpleLayout}
          getCtaWidgetPurpleLayout={isCtaPurpleLayout}
          hideSection={getHideSectionState(0, content?.widget, isMobileDevice)}
        />
      </div>

      {shouldDisplayWidget(content?.widget, ContainerVisibility.SHOW) && (
        <ProductLobWidget
          content={content}
          isMobileDevice={isMobileDevice}
          segmentEventCommonProperties={segmentEventCommonProperties}
          reqCookie={reqCookie}
          isSemPage={isSemPage}
          isOldLayout={isOldLayout}
          regexPatternsData={regexPatternsData}
          isHealthWidgetPurpleLayout={isHealthWidgetPurpleLayout}
          widgetVisibleAlways={isHealthWidgetPurpleLayout}
          widgetOptions={content?.widgetOptions}
        />
      )}

      <ProductKeyFeaturesAndCta
        content={content}
        isMobileView
        isAutoWidgetLayout={isAutoWidgetLayout}
        isSeoCarWidget={isSeoCarWidget}
        THEME_CONFIG={THEME_CONFIG}
        segmentEventCommonProperties={segmentEventCommonProperties}
        renderCtaButton={false}
        isHealthWidgetPurpleLayout={isHealthWidgetPurpleLayout}
        hideSection={getHideSectionState(1, content?.widget, isMobileDevice)}
        getCtaWidgetPurpleLayout={isCtaPurpleLayout}
      />

      {shouldDisplayWidget(content?.widget, ContainerVisibility.HIDE) && (
        <Image
          src={content?.productWidgetHeroImageDesktop?.data?.attributes?.url}
          alt="Hero image desktop"
          width={getHeroImageSize(isSeoCarWidget, isCtaPurpleLayout)}
          height={getHeroImageSize(isSeoCarWidget, isCtaPurpleLayout)}
          className={heroImageContainerClassNames}
          priority
        />
      )}

      <WidgetModal
        isMobileDevice={isMobileDevice}
        content={content}
        bottomFloaterWidgetCta={content?.widget}
        segmentEventCommonProperties={segmentEventCommonProperties}
        reqCookie={reqCookie}
        isSemPage={isSemPage}
        productWidgetData={productWidgetData}
        regexPatternsData={regexPatternsData}
      />
    </div>
  )
}

export default ProductWidget
